


export default function SimulationAnylogicPage() {

    return (

        <div className="pg-content" >

            <h1 className="mb-5">
                Simuação Anylogic
            </h1>
            
            <iframe 
                title="SimulacaoAnylogic"
                width="100%" 
                height="650px" 
                allow="fullscreen" 
                src="https://cloud.anylogic.com/assets/embed?modelId=bccd3d2a-d4e4-439a-b2bd-a170e97a16a0">

            </iframe>
              
        </div>
    )


}